import { gql } from "@apollo/client";

export const CLEAR_MY_ENABLED_CARDS = gql`
  mutation Mutation {
    clearMyEnabledCards
  }
`;
